import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CacheService {

    private cache: Map<string, any> = new Map<string, any>();

    constructor() {
    }

    set(key: string, value: any) {
        this.cache.set(key, value);
    }

    has(key: string): boolean {
        return this.cache.has(key);
    }

    get(key: string): any {
        return this.cache.get(key);
    }

    clear(...keys: string[]) {
        keys.forEach((key) => {
            this.cache.delete(key);
        });
    }

    clearAll() {
        this.cache.clear();
    }
}
